import { PayloadAction } from 'typesafe-actions';
import { AccountListContextActionTypes, AccountListState } from './types';

const AccountListReducer = (
  state: AccountListState,
  action: PayloadAction<AccountListContextActionTypes, any>,
): AccountListState => {
  switch (action.type) {
    default: {
      return state;
    }
  }
};

export { AccountListReducer };
